import type { FileSharePermission, ShareLinkAudience } from "@/api/files-hub/fileShares.api";

export const PERMISSION_OPTIONS: { value: FileSharePermission; label: string }[] = [
  { value: "VIEW", label: "Can view" },
  { value: "EDIT", label: "Can edit" },
];

export const permissionLabel = (permission: FileSharePermission) =>
  PERMISSION_OPTIONS.find((option) => option.value === permission)?.label ?? permission;

export interface AudienceText {
  label: string;
  description: string;
  linkSummary: string;
}

export function audienceTexts(entityName: string): Record<ShareLinkAudience, AudienceText> {
  return {
    RESTRICTED: {
      label: "Restricted",
      description: "Only people with access can open with the link",
      linkSummary: "Restricted link",
    },
    ENTITY: {
      label: `Everyone in ${entityName}`,
      description: `Anyone in ${entityName} with the link can view`,
      linkSummary: `Anyone in ${entityName} with the link`,
    },
    ENTITY_ROLES: {
      label: "People with selected roles",
      description: `People in ${entityName} with one of the chosen roles and the link`,
      linkSummary: "People with selected roles",
    },
    CLIENT_TEAM: {
      label: "This client's team",
      description: "People on this client's team with the link",
      linkSummary: "Client team",
    },
  };
}
